import { render, staticRenderFns } from "./ViewLoginHub.vue?vue&type=template&id=bd779586&scoped=true&"
import script from "./ViewLoginHub.vue?vue&type=script&lang=ts&"
export * from "./ViewLoginHub.vue?vue&type=script&lang=ts&"
import style0 from "./ViewLoginHub.vue?vue&type=style&index=0&id=bd779586&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd779586",
  null
  
)

export default component.exports